<script>
import moment from 'moment'
import facebookIcon from '@/assets/images/icons/socials/facebook.svg?inline'
import vkIcon from '@/assets/images/icons/socials/vk.svg?inline'
import zenIcon from '@/assets/images/icons/socials/zen.svg?inline'
import instagramIcon from '@/assets/images/icons/socials/instagram.svg?inline'
import youtubeIcon from '@/assets/images/icons/socials/youtube.svg?inline'

export default {
  name: 'AppFooter',
  components: {
    facebookIcon,
    vkIcon,
    zenIcon,
    instagramIcon,
    youtubeIcon
  },
  computed: {
    copyrightYear: () => `2005-${moment().format('YYYY')}`
  }
}
</script>

<template>
  <footer class="app-footer">
    <div class="app-footer__grid app-content">
      <div class="app-footer__logo">
        <img src="@/assets/images/rex-logo-white.png">
        <div class="app-footer__logo-text">
          <p>Русский Экспресс — туроператор ярких впечатлений!</p>
          <p>{{ copyrightYear }}. Все права защищены</p>
        </div>
      </div>
      <div class="app-footer__menus">
        <div class="app-footer__menu">
          <h4 class="app-footer__menu-header">
            Поиск
          </h4>
          <ul>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Туры
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Отели
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Авиабилеты
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Страхование
              </a>
            </li>
          </ul>
        </div>
        <div class="app-footer__menu">
          <h4 class="app-footer__menu-header">
            Русский Экспресс
          </h4>
          <ul>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                О компании
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Новости
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Структура и продукты
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Финансовое обеспечение
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Карьера
              </a>
            </li>
          </ul>
        </div>
        <div class="app-footer__menu">
          <h4 class="app-footer__menu-header">
            Туристам
          </h4>
          <ul>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Финансовые гарантии
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Поддержка
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Способы оплаты
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Частые вопросы
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Контакты
              </a>
            </li>
          </ul>
        </div>
        <div class="app-footer__menu">
          <h4 class="app-footer__menu-header">
            Центры продаж
          </h4>
          <ul>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Москва
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Санкт-Петербург
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Екатеринбург
              </a>
            </li>
          </ul>
        </div>
        <div class="app-footer__menu">
          <h4 class="app-footer__menu-header">
            Подписывайтесь
          </h4>
          <div class="app-footer__socials">
            <a href="javascript:;">
              <vk-icon />
            </a>
            <a href="javascript:;">
              <zen-icon />
            </a>
            <a href="javascript:;">
              <instagram-icon />
            </a>
            <a href="javascript:;">
              <youtube-icon />
            </a>
            <a href="javascript:;">
              <facebook-icon />
            </a>
          </div>
        </div>
        <div class="app-footer__menu">
          <h4 class="app-footer__menu-header">
            Каталог
          </h4>
          <ul>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Страны
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Подборки туров
              </a>
            </li>
          </ul>
        </div>
        <div class="app-footer__menu">
          <h4 class="app-footer__menu-header">
            Полезная информация
          </h4>
          <ul>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Прием документов
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Страхование в поездке
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Визы
              </a>
            </li>
          </ul>
        </div>
        <div class="app-footer__menu">
          <h4 class="app-footer__menu-header">
            Агентствам
          </h4>
          <ul>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Стать агентом
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Вебинары и мероприятия
              </a>
            </li>
          </ul>
        </div>
        <div class="app-footer__menu">
          <h4 class="app-footer__menu-header">
            Представительства
          </h4>
          <ul>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Омск
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Краснодар
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                class="app-footer__menu-link"
              >
                Самара
              </a>
            </li>
          </ul>
        </div>
        <div class="app-footer__menu">
          <a
            href="tel:+74950096699"
            class="app-footer__phone"
          >
            +7 (495) 009-66-99
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
